<template>
  <section class="c-google-map" id="c-google-map">
    <div class="c-google-map__iframe" id="gmap"></div>
  </section>
</template>

<script>
import classNames from 'classnames';

export default {
  name: "GoogleMap",
  props: ['markerCoordinates', 'selectLocation', 'vanPath', 'focusedTootip'],
  data: function () {
    return {
      mapName: this.name + "-map",
      map: null,
      bounds: null,
      markers: [],
      tooltips: [],
      polyline: null
    }
  },
  watch: {
    markerCoordinates: function(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.markerCoordinates = newVal;
        this.loadMap();
      }
    },
    focusedTootip: function(id) {
      this.tooltips.forEach(t => {
        t.iw[t.id === id ? 'open' : 'close'](t.iw.map, t.marker); 
      })
    }
  },
  mounted: function(){
    this.loadMap();
  },
  methods: {
    loadMap () {
      const google = window.google;
      const MarkerWithLabel = require('markerwithlabel')(google.maps);
      this.tooltips = [];
      this.bounds = new google.maps.LatLngBounds();
      const element = document.getElementById('gmap')
      const mapCentre = this.markerCoordinates[0]
      const { lat, long} = mapCentre || { lat:0, long:0 };
      const options = {
        center: new google.maps.LatLng(lat,long),
        //scaleControl: false,
        //zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        maxZoom : 15
      }
      this.map = new google.maps.Map(element, options);
      this.markerCoordinates.forEach((coord) => {
        
        const position = new google.maps.LatLng(coord.lat, coord.long);

        var markerIcon = {
          url: '',
          scaledSize: new google.maps.Size(20, 20),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(32,65)
        };

        var marker = new MarkerWithLabel({
          map: this.map,
          position: position,
          icon: markerIcon,
          labelContent: '',
          labelAnchor: new google.maps.Point(15, 35),
          labelInBackground: true,
          labelClass: classNames(`c-map-marker --status-${coord.status}`, {
            '--push-left' : coord.id > 9,
            '--with-tooltip' : coord.tooltip
          })
        });

        if(coord.tooltip){
          const iw = new google.maps.InfoWindow({ 
            content: coord.tooltip,
            pixelOffset: new google.maps.Size(22,20),
            map: this.map
          });
          google.maps.event.addListener(marker, "mouseover", function () { iw.open (this.map, marker); });
          google.maps.event.addListener(marker, "mouseout",  function () { iw.close(this.map, marker); });
          this.tooltips.push({ id: coord.id, marker, iw });
        }

        marker.addListener('click', () => this.selectLocation(coord.id.toString()));
        this.map.fitBounds(this.bounds.extend(position))
      });

      this.polyline = new google.maps.Polyline({
        path: this.vanPath,
        geodesic: true,
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 4
      });
      this.polyline.setMap(this.map)

    }
  }
};
</script>

<style lang="scss">
  @import './../assets/scss/config/_variables';

  .c-google-map {
    position: relative;
    width: 100%;
    height: 300px;
    &__iframe {
      height: 100%;
      width: 100%;
      overflow: hidden;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
    }
  }

  .c-map-marker {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 40px;
    height: 40px;
    padding-left: 12px;
    padding-top: 8px;
    font-weight: bold;
    z-index: 1;
    &::before {
      content: '';
      width: 30px;
      height: 30px;
      border-radius: 50% 50% 50% 0;
      position: absolute;
      transform: rotate(-45deg);
      left: 50%;
      top: 50%;
      margin: -20px 0 0 -20px;
      z-index: -1;
      background-color:$color-d1;
    }
    &::after {
      width: 20px;
      height: 20px;
      position: absolute;
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      -webkit-font-smoothing: antialiased;
      display: inline-block;
      color: #ffffff;
      z-index: 1;
      text-align:center;
      position:absolute;
      right: 0;
      left: 0;
      bottom: 0;
      top: 0;
      margin:auto;
      padding-right:7px;
    }
    &.--status-van::after {
      content: "\f0d1";
      transform: translate(-1px);
    }
    &.--status-home::after {
      content: "\f015";
      font-size: 14px !important;
      text-align: center;
      padding: 0;
      display: inline-block;
      left: -9px;
    }

    &.--list-view {
      left: -5px;
      top: 10px;
      font-size: 12px;
      &::before {
        margin: -19px 0 0 -8px;
      }
      &::after {
        margin: -2px 0px 0px -13px;
      }
      &.--push-left {
        padding-left: 13px;
        padding-top: 18px;
      }
    }
    &.--push-left {
      padding-left: 9px;
      &::after {
        margin: -4px 0px 0px -16px;
      }
    }
    &.--status-late {
      &::before {
        background: #ffdb58;
      }
    }
    &.--status-failed {
      &::before {
        background: $color-d11;
      }
    }
    &.--status-unknown {
      &::before {
        background: #cccccc;
      }
    }
  }
</style>
